import axios from "axios";

const dominio = process.env.REACT_APP_DOMINIO;

async function buscarClaveSIC(clave) {
  let urlBusquedaSIC = `${dominio}/emisoras/sic/busqueda/${clave}`;
  return axios.get(urlBusquedaSIC).catch(e => "Error al obtener el ID de la clave SIC. " + e.message);
}

export async function generarRutaPerfilSIC(clave) {
  let resultadoBusqueda = await buscarClaveSIC(clave);
  if(resultadoBusqueda) {
    return `/empresas/emisoras_inscritas/sic?tab=0&subTab=0&clave=${clave}&emisora=${resultadoBusqueda.data[0].id}&page=1`;
  }
}
